export function LoadingState({ label = 'Đang tải…' }: { label?: string }) {
  return (
    <div style={{ flex: 1, minHeight: 160, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <span
        aria-label={label}
        role="status"
        style={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          border: '3px solid var(--border-default)',
          borderTopColor: 'var(--cta-default)',
          animation: 'torii-spin 0.8s linear infinite',
        }}
      />
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div style={{ flex: 1, minHeight: 160, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 24, gap: 16, textAlign: 'center' }}>
      <p style={{ margin: 0, fontSize: 15, color: 'var(--error)', lineHeight: 1.5, maxWidth: 420 }}>{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            height: 44,
            padding: '0 20px',
            borderRadius: 'var(--radius-control)',
            background: 'var(--surface-tint)',
            border: '1px solid var(--border-default)',
            color: 'var(--ink)',
            cursor: 'pointer',
            fontFamily: 'var(--font-vi)',
            fontWeight: 600,
            fontSize: 14.5,
          }}
        >
          Thử lại
        </button>
      )}
    </div>
  );
}
